<template>
  <div class="account-page" style="height: 100vh;">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <div class="container">
          <!-- Account Logo -->
          <div class="account-logo">
            <img src="@/assets/img/logo.png" style="width: 200px;" />
          </div>
          <!-- /Account Logo -->

          <v-card class="account-box" elevation="6">
            <div class="account-wrapper">
              <br />

              <!-- Account Form -->

              <div class="form-group">
                <v-text-field
                  label="Username"
                  outlined
                  dense
                  v-model="username"
                  prepend-icon="mdi-account-circle"
                />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col"></div>
                  <div class="col-auto">
                    <router-link
                      class="text-muted"
                      v-show="pwd"
                      to="/forgot-password"
                    >
                      Forgot password?
                    </router-link>
                  </div>
                </div>
                <v-text-field
                  outlined
                  dense
                  label="Password"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  v-model="password"
                />
              </div>

              <div class="form-group text-center">
                <button
                  class="btn btn-primary account-btn"
                  @click="loginSubmit"
                >
                  <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  Login
                </button>
              </div>

              <FlashMessage></FlashMessage>
              <!-- /Account Form -->
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <!-- /Main Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script>
import { userData, curd, getLogo } from '../service/CallWebService'
import CryptoJS from 'crypto-js'
const BASE_API = require('../service/prod.env')
import Login1 from './Login1'
import axios from 'axios'
export default {
  name: 'Login',
  components: { Login1 },
  data() {
    return {
      pwd: false,
      username: '',
      logoid: '',
      password: '',
      language: '',
      showPassword: false,
      loading: false,
      logindetails: '',
      roles: '',
      jwt: '',
    }
  },
  methods: {
    loginSubmit() {
      this.loading = true
      var enpassword = CryptoJS.AES.encrypt(
        this.password,
        'secretkey123',
      ).toString()
      const decryptData = CryptoJS.AES.decrypt(
        enpassword,
        'secretkey123',
      ).toString(CryptoJS.enc.Utf8)

      axios
        .post(BASE_API.NODE_ENV + '/authenticate', {
          login: {
            username: this.username,
            password: this.password,
            language: 0,
          },
        })
        .then((response) => {
          this.jwt = response.data.jwt
          console.log('axios token sess', response.data)
          if (response.data.status == 'N') {
            this.flashMessage.warning({ message: response.data.message })
            this.loading = false
          }
          if (response.data.status != 'N') {
            let base64Url = this.jwt.split('.')[1]
            let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            let jsonPayload = decodeURIComponent(
              atob(base64)
                .split('')
                .map(function (c) {
                  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                })
                .join(''),
            )

            this.logindetails = JSON.parse(jsonPayload)
            localStorage.setItem(
              'AD_Client_ID',
              JSON.stringify(this.logindetails.AD_Client_ID),
            )
            localStorage.setItem(
              'AD_User_ID',
              JSON.stringify(this.logindetails.AD_User_ID),
            )
            console.log('userrrrrr', JSON.stringify(this.jwt))
            localStorage.setItem('user', JSON.stringify(this.jwt))
          }

          localStorage.setItem('role', JSON.stringify(response.data.Role))
          if (response.data.Role.length > 1) {
            this.$router.push('/role')
          } else if (
            response.data.Role.length === 1 &&
            response.data.Role[0].Org.length > 1
          ) {
            this.$router.push('/role')
          } else {
            this.getData()
          }
        })
    },
    getData() {
      const playload = { AD_Org_ID: '', AD_Role_ID: '' }
      userData(playload).then((response) => {
        console.log('userData ', response)
        localStorage.setItem(
          'HM_Employ_ID',
          JSON.stringify(response.HM_Employ_ID),
        )
        localStorage.setItem('user', JSON.stringify(response.jwt))
        let base64Url = JSON.stringify(response.jwt).split('.')[1]
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join(''),
        )

        this.logindetails = JSON.parse(jsonPayload)
        localStorage.setItem(
          'AD_Client_ID',
          JSON.stringify(this.logindetails.AD_Client_ID),
        )
        localStorage.setItem(
          'AD_Org_ID',
          JSON.stringify(this.logindetails.AD_Org_ID),
        )
        this.getOrgLogoID()
        localStorage.setItem(
          'AD_Role_ID',
          JSON.stringify(this.logindetails.AD_Role_ID),
        )
        localStorage.setItem(
          'AD_Session_ID',
          JSON.stringify(this.logindetails.AD_Session_ID),
        )
        localStorage.setItem(
          'AD_User_ID',
          JSON.stringify(this.logindetails.AD_User_ID),
        )
        localStorage.setItem(
          'AD_Warehouse_ID',
          JSON.stringify(this.logindetails.AD_Warehouse_ID),
        )

        localStorage.setItem('role', JSON.stringify(response.role))
        localStorage.setItem('username', JSON.stringify(response.name))
        localStorage.setItem('userimage', JSON.stringify(response.empimageurl))

        if (response.HM_Employ_ID > 0) {
          console.log('logindetails ', this.logindetails.AD_Role_ID)
          if (this.logindetails.AD_Role_ID > 0) {
            const payload = {
              Method: 'getESSRoleMenu',
              Input: {
                AD_Role_ID: Number(
                  JSON.parse(localStorage.getItem('AD_Role_ID')),
                ),
                ad_client_id: Number(
                  JSON.parse(localStorage.getItem('AD_Client_ID')),
                ),
              },
              ServiceParameter: { all: 'all' },
            }
            console.log('getESSRoleMenu request', payload)
            curd(payload).then((response) => {
              console.log('getESSRoleMenu', response)
              localStorage.setItem('user', JSON.stringify(response.jwt))
              localStorage.setItem('Menu', JSON.stringify(response.output))
              if (response.output.length > 0) {
                this.$router.push('/profile')
              } else {
                this.flashMessage.warning({
                  message: 'Role is unable to assign a menu',
                })
              }
            })
          }
        } else {
          this.flashMessage.warning({
            message: 'Employee Not Mapped. Please contact with Administrator',
          })
        }
      })
    },
    clear() {
      this.username = ''
      this.password = ''
      this.language = ''
    },
    getOrgLogoID() {
      const payload = {
        Method: 'getOrgLogoID',
        Input: {
          ad_client_id: Number(
            JSON.parse(localStorage.getItem('AD_Client_ID')),
          ),
          ad_org_id: Number(JSON.parse(localStorage.getItem('AD_Org_ID'))),
        },
        ServiceParameter: { all: 'all' },
      }
      curd(payload).then((response) => {
        console.log('getOrgLogoID', response)

        this.logoid = response.output[0].logo_id
        this.getlogo()
      })
    },
    getlogo() {
      const payload = {
        LogoID: this.logoid,
      }

      console.log('companylogo request', payload)
      getLogo(payload).then((response) => {
        console.log('companylogo', response)

        localStorage.setItem('companylogo', JSON.stringify(response.base64))
        console.log('companylogo', response.base64)
      })
      /* getLogo(payload).then((response) => {
        console.log('enterrrrrrrrrrrrrrrrrrrr', response)
        // this.img=response.base64
        localStorage.setItem('companylogo', JSON.stringify(response.base64))
        console.log('', response.base64)
      })*/
    },
  },
  mounted() {
    localStorage.clear()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page/Login.vue